<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/shared-inbox-software.mjs";
</script>
